import { DeviceType, DeviceTypeMap } from 'shared/models';

export const Actions = {
    GET_DEVICETYPES_REQUEST: 'GET_DEVICETYPES_REQUEST',
    GET_DEVICETYPES_SUCCESS: 'GET_DEVICETYPES_SUCCESS',
    GET_DEVICETYPES_FAILURE: 'GET_DEVICETYPES_FAILURE',

    UPDATE_DEVICETYPE_SUCCESS: 'UPDATE_DEVICETYPE_SUCCESS',

    DELETE_DEVICETYPE_SUCCESS: 'DELETE_DEVICETYPE_SUCCESS',
};


export const getDeviceTypesRequest = () => ({
    type: Actions.GET_DEVICETYPES_REQUEST,
});
export const getDeviceTypesSuccess = (deviceTypes: DeviceTypeMap) => ({
    type: Actions.GET_DEVICETYPES_SUCCESS,
    payload: deviceTypes,
});
export const getDeviceTypesFailure = (err: Error) => ({
    type: Actions.GET_DEVICETYPES_FAILURE,
    error: true,
    payload: err,
});

export const updateDeviceTypeSuccess = (deviceType: DeviceType) => ({
    type: Actions.UPDATE_DEVICETYPE_SUCCESS,
    payload: deviceType,
    meta: { id: deviceType.id },
});

export const deleteDeviceTypeSuccess = (id: string) => ({
    type: Actions.DELETE_DEVICETYPE_SUCCESS,
    payload: null,
    meta: { id },
});
